import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledSignalsPromoBannerWrapper = styled.div`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 16px;
    padding: 20px 24px 16px 0px;
    border-radius: 6px;
    background: ${colorsPalettes.blue[100]};
`;

export const StyledSignalsPromoBannerImage = styled.img`
    width: 90px;
    height: 90px;
`;

export const StyledSignalsPromoBannerContent = styled.div`
    margin-left: 19px;
`;

export const StyledSignalsPromoBannerTitle = styled.p`
    ${mixins.setFontVariant("subsectionTitle", colorsPalettes.carbon["500"])};
    margin: 0 0 5px;
`;

export const StyledSignalsPromoBannerSubtitle = styled.p`
    ${mixins.setFontVariant("body2", colorsPalettes.carbon["500"])};
    margin: 0;
`;

export const StyledSignalsPromoBannerButton = styled.div`
    margin-top: 8px;
`;
